var React = require('react');

function IconArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M28 14.5H9.745l8.385-8.385L16 4 4 16l12 12 2.115-2.115-8.37-8.385H28z","transform":"translate(-4 -4)"}));
}

IconArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconArrowLeft;

IconArrowLeft.default = IconArrowLeft;
